import React from "react";
import appVersion from "../../version";
import preval from 'preval.macro'

export const Footer = () =>{
    return (
        <footer>
            <p>App Version: {appVersion}</p>
            <p>
                Released on: {preval`module.exports = new Date().toLocaleString();`}.
            </p>
        </footer>

    )
}
